export default __webpack_public_path__ + "static/media/ba5.a3160b92.jpg";